
<script setup>
import { ref, onBeforeMount, onUpdated, watch, reactive, getCurrentInstance, computed } from 'vue';
import { inject } from 'vue';
import SkillWorkspace from "@/components/skills/cSkillWorkspace";
import SkillAdmin from "@/components/skills/cSkillAdmin";
import AdminTags from '@/components/admin/cAdminTagsAlt.vue'
import LandingHolder from '@/views/vLandingHolder.vue';

const loginState = inject('loginState');
const store = inject('store');
const router = inject('router');

const skillManagerData = reactive({
    loading: true,
    tabs: [
      "Skills Dashboard",
      "Skills Workspace",
      "Skills Framework Admin",
      "Market Insights"
    ],
    skillTab: null, // Will be set to default tab
    primaryTabs: [
      { key: "home", title: "", icon: "mdi-home", iconColour: "#50B3CB", borderColour: "#A7D9E5", width: "120px", visible: true},
      { key: "workspace", title: "Skills Workspace", icon: "mdi-dots-triangle", iconColour: "#FFCB00", borderColour: "#FFE580", width: "", visible: true, default: true  },
      { key: "dashboard", title: "Skills Dashboard", icon: "mdi-view-dashboard", iconColour: "#EA3785", borderColour: "#F7AFCE", width: "", visible: true, },
      { key: "admin", title: "Skills Admin", icon: "mdi-cog", iconColour: "#CEDC26", borderColour: "#E2EA7D", width: "", visible: true, },
    ],
})

// Set default tab on component creation
onBeforeMount(() => {
  const defaultTab = skillManagerData.primaryTabs.find(tab => tab.default);
  if (defaultTab) {
    skillManagerData.skillTab = defaultTab;
  }
});

const selectTab = (tab) => {
  skillManagerData.skillTab = tab;
};

function changeRoute(route){
  router.push(route);
}
</script>
<template>
  <v-card class="skillsManager" flat>
    <v-row class="flex-nowrap" style="padding:40px 40px 0px 40px">
      <v-col v-for="(t, ti) in skillManagerData.primaryTabs.filter(x => x.visible)"
          :style="{ width: t.width, maxWidth: t.width }" @click="selectTab(t)"
          :key="'tab' + ti">
          <div class="rm-primary-tab rm-box" style="cursor: pointer;" 
            :style="t === skillManagerData.skillTab ? 'border: 4px solid ' + t.borderColour : ''"
            :class="t === skillManagerData.skillTab ? 'tab-selected' : ''">
          <v-icon v-if="t.icon" :color="t.iconColour" class="mr-4 rm-primary-tab-icon">{{ t.icon }}</v-icon>
          {{t.title}}
        </div>
      </v-col>
    </v-row>
    <div class="tab-content">
      <!-- Home Tab -->
      <div v-if="skillManagerData.skillTab?.key === 'home'" class="tabItem home">
        <div class="text-center py-12">
          <v-icon size="64" color="grey lighten-2">mdi-home</v-icon>
          <h2 class="mt-4 text-h5">Home Page</h2>
          <p class="text-body-1 mt-2">Home page functionality coming soon...</p>
        </div>
      </div>
      
      <!-- Skills Workspace Tab -->
      <div v-else-if="skillManagerData.skillTab?.key === 'workspace'" class="tabItem workspace">
        <SkillWorkspace @openDocument="$emit('openDocument',$event)" />
      </div>
      
      <!-- Skills Dashboard Tab -->
      <div v-else-if="skillManagerData.skillTab?.key === 'dashboard'" class="tabItem dashboard">
        <LandingHolder config="skillsdashboard"></LandingHolder>
      </div>
      
      <!-- Skills Admin Tab -->
      <div v-else-if="skillManagerData.skillTab?.key === 'admin'" class="tabItem admin">
        <AdminTags />
      </div>
    </div>  
  </v-card>  
</template>
<style lang="scss" scoped>


.skillsManager { 
  width: 100%;
  height: calc(100vh - 50px);
  max-height: calc(100vh - 50px);
  padding: 0px 0px 0px 0px;
}

.tab-content {
  padding-top: 20px;
}

.tabItem {
  width: 100%;
}

.tabItem.home {
  padding: 0px 40px;
}

.skillsTabs {
  width: 50%;
  max-height: calc(100vh - 240px);
  padding: 0px 0px 0px 40px;
}

.tabItem.workspace {
  height: calc(100vh - 210px);
  max-height: calc(100vh - 210px);
  overflow: hidden;
  padding: 0px 0px 0 0px;
}

.tabItem.dashboard {
  height: calc(100vh - 210px);
  max-height: calc(100vh - 210px);
  overflow: scroll;
  padding: 0px 0px 0 0px;
}

.tabItem.admin {
  padding: 0px 45px 0 40px;
  overflow: scroll;
  padding-left: 5px;
}

.rm-primary-tab-icon {
  font-size: 50px !important;
}
.rm-primary-tab {
  height: 90px;
  padding: 20px 24px;
  font-family: "DM Serif Display" !important;
  font-weight: 400;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: 0;
  color: #000000;
}
.rm-primary-tab.tab-selected {
  padding: 16px 20px;
}
.rm-box {
  background-color: #FFFFFF;
  border-radius: 24px !important;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, .08) !important;
}
</style>